import React from "react";

import ButtonSettings from "./features/button/ButtonSettings";
import CountdownSettings from "./features/countdown/CountdownSettings";
import PanelsSettings from "./features/panels/PanelsSettings";
import AnnouncementsSettings from "./features/announcements/AnnouncementsSettings";
import CardsSettings from "./features/cards/CardsSettings";
import SpacerAndDividerSettings from "./features/spacer-and-divider/SpacerAndDividerSettings";
import TextAndTitleSettings from "./features/text-and-title/TextAndTitleSettings";
import ImageSliderSettings from "./features/image-slider/ImageSliderSettings";
import AdvancedTabsGroupSettings from "./features/advanced-tabs/group/AdvancedTabsGroupSettings";
import FootnoteDisplaySettings from "./features/footnote-display/FootnoteDisplaySettings";
import TooltipFootnoteSettings from "./features/tooltip-footnote/TooltipFootnoteSettings";
import AdvancedTabsSingleSettings from "./features/advanced-tabs/single/AdvancedTabsSingleSettings";
import PanelAdvancedSettings from "./features/panel-advanced/PanelAdvancedSettings";
import { useOpticsStore } from "../../../../stores/use-optics-store";
import { MACRO_KEY } from "../../../defaults";
import { SettingsContainer } from "./styles";
import { macroStores } from "../../../../stores/export-stores";

const settingsComponents = {
  undefined: () => <></>,
  [MACRO_KEY.BUTTON]: ButtonSettings,
  [MACRO_KEY.BUTTON_INLINE]: ButtonSettings,
  [MACRO_KEY.COUNTDOWN]: CountdownSettings,
  [MACRO_KEY.PANEL_SIMPLE]: PanelsSettings,
  [MACRO_KEY.ANNOUNCEMENTS]: AnnouncementsSettings,
  [MACRO_KEY.CARDS]: CardsSettings,
  [MACRO_KEY.SPACER_AND_DIVIDER]: SpacerAndDividerSettings,
  [MACRO_KEY.TEXT_AND_TITLE]: TextAndTitleSettings,
  [MACRO_KEY.IMAGE_SLIDER]: ImageSliderSettings,
  [MACRO_KEY.ADVANCED_TABS_GROUP]: AdvancedTabsGroupSettings,
  [MACRO_KEY.ADVANCED_TABS_SINGLE]: AdvancedTabsSingleSettings,
  [MACRO_KEY.FOOTNOTE_DISPLAY]: FootnoteDisplaySettings,
  [MACRO_KEY.TOOLTIPS_AND_FOOTNOTES]: TooltipFootnoteSettings,
  [MACRO_KEY.PANEL_ADVANCED]: PanelAdvancedSettings,
};

const NoComponent = () => <></>;

const Settings = () => {
  const { macro } = useOpticsStore((state) => ({
    macro: state.macro,
  }));

  const macroData = macroStores[macro]?.((state) => state?.data || {});
  const hasMacroData = Array.isArray(macroData)
    ? !!macroData.length
    : !!Object.keys(macroData).length;

  const SettingsComponent = settingsComponents[macro] || NoComponent;

  if (!hasMacroData) return <></>;

  return (
    <SettingsContainer>
      <SettingsComponent editorMacro={macro} />
    </SettingsContainer>
  );
};

export default Settings;
